module.exports = __webpack_public_path__ + "static/media/4rods1cocci1yeast.2a61ff9a.jpg";